import HttpFactory from '@/mixins/http.factory';
import HtmlEditor from '@/components/Inputs/HtmlEditor'
export default {
	name:'work-item-log',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			editorObj:null,
			linkedWorkItem:{attachments:[]},
			notifyData:{commentText:null,attachments:[],files:[]},
			workItemLog:{workItem:null,comments:null,show:false,showNoComments:false},
			mondayInfo: { credentials: null, user: null, item: null, origin: null, app_guid: null, attachments: [], linkedItems: [] },
			showForm:true
		}
	},
	created(){
		this.init();
	},
	components:{HtmlEditor},
	methods:{
		async init(){
			let _self = this;
			
			let data = await _self.fn().getMondayData_Child(_self.$route.params.appId,_self.$route.params.installationId,_self.$route.params.hdBoardId, _self.$route.params.hdItemId);
			_self.mondayInfo = data;
			var triggerInstance = `work-item-log-dialog_md${_self.$route.params.hdItemId}_wd${_self.mondayInfo.linkData.workItemId}`
			
			//_self.auth.userId = _self.mondayInfo.userInfo ? _self.mondayInfo.userInfo.id : null;
            //_self.auth.hdLoginUrl=_self.mondayInfo.credentials.hdLoginUrl;
			//_self.auth.hdEmail = _self.mondayInfo.user.email;
			
			_self.linkedWorkItem = _self.mondayInfo.linkData;
			_self.workItemLogFn(true);
			setTimeout(function(){_self.initDropzone(data);},500);
			setTimeout(function(){_self.fn().createHtmlEditor('editor');},1000);
		},
		workItemLogFn(isInit){
			let _self=this;
			let linkData=_self.linkedWorkItem;
			_self.notifyData.hdBoardId = linkData.hdBoardId;
			_self.notifyData.hdItemId = linkData.hdItemId;
			_self.notifyData.devOpsTenant=linkData.devOpsTenant;
			//_self.notifyData.workItemId=linkData.workItemId;
			let data=linkData;
			data.auth=_self.mondayInfo.credentials;
			var url = `monday/showLog/${linkData.hdBoardId}/${linkData.hdItemId}/${encodeURIComponent(linkData.workItemId)}`;
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				let workItemLog = response.data.Data;
				if (workItemLog.workItem) {
					_self.notifyData.workItemId = workItemLog.workItem.id;
					_self.notifyData.projectId = workItemLog.workItem.fields['System.TeamProject'];
				}
				workItemLog.showNoComments=false;
				if(!workItemLog.comments || !workItemLog.comments.comments || workItemLog.comments.comments.length<=0){
					workItemLog.showNoComments=true;
				}
				_self.workItemLog=workItemLog;
				
			}).catch(error=>{
				_self.commonErrorMsgDisp(error);
			});
		},
		initDropzone(data){
			const _self=this;
			if (!data || !data.userInfo || !data.userInfo.uploadFiles) return;
			data.credentials.devOpsTenant = _self.linkedWorkItem.devOpsTenant;
			_self.fn().initDropzone('div.dropzone',data.credentials,'devops',function(error,response){
				_self.fn().clearMessage();
				if(error){
					_self.userMsg={show:true,type:'danger',list:[response?response:error]}
					return;
				}
				_self.notifyData.files=_self.notifyData.files.concat(response);
			});
		},
		removeFile(file){
			const _self=this;
			_self.notifyData.files=_self.notifyData.files.filter(d=>d.id!=file.id);
		},
		notifyWorkItemFn(){
			let _self=this;
			_self.fn().clearMessage();
			let data=_self.notifyData;
			if(_self.editorObj)
            	data.commentText=_self.fn().getHtmlEditorContent();
            
			if(!data.commentText || data.commentText.trim()==''){
				_self.userMsg={show:true,type:'danger',list:[`Please enter the comment description`]}
				return;
			}
			data.auth=_self.mondayInfo.credentials;
			data.user=_self.mondayInfo.user;
			data.hdItemId = _self.mondayInfo.item.id;
			if (!_self.linkedWorkItem.workItemUrl) { data.workItemIds = [{ id: data.workItemId, projectId: data.projectId, devOpsTenant: data.devOpsTenant }]; }//temp for the parent/child log screen
			
			let url=`monday/notifylinked/${data.hdBoardId}/${data.hdItemId}/${data.workItemId}`
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				if(response.data.Success){
					_self.notifyData.attachments=[];
					_self.notifyData.files = [];
					_self.notifyData.commentText = null;
					_self.workItemLogFn();
					let userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Workitem: #${data.workItemId} notified Successfully`]}
					_self.userMsg=userMsg;
					_self.fn().clearHtmlEditorContent();
					_self.showForm = false;
					setTimeout(function () { _self.showForm = true }, 500);
					//_self.sendDataToParent(response.data);
				}
				_self.data=response.data.Data;
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		htmlEditorChange(data){
			const _self=this;
			_self.notifyData.commentText=data.htmlContent?data.htmlContent:null;
		},
		closeDialog(data) {
			let _self= this;
			_self.fn().close_monday_modal(data);
		},
        sendDataToParent(data) {
            let _self = this;
            _self.closeDialog(data);
		},
	}
}

